import React, { Component } from "react";
import MainLayout from "../mainLayout/index";
import FpgMinusIcon from "../icons/fpgminusicon";
import FpgPlusIcon from "../icons/fpgplusicon";
import CatEditIcon from "../icons/catediticon";
import TextField from "../component/TextField";
//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//Validation import
import SimpleReactValidator from "simple-react-validator";

//sweet alert
import swal from "sweetalert";

//Service import
import service from "../services";
import Loader from "../component/loader";
import Tablist from "./Tablist";

let sub;

class FilmCreditLebel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      name: "",
      description: "",
      loaderFlag: false,
      changeCreditLebelTitleName: false,
      getAllCreditLebelDetails: [],
      getAllCreditLebelDocs: [],
      id: "",
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.tablistRef = React.createRef();
  }
  AddCategory = () => {
    this.setState({
      addCatmodal: true,
      name: "",
      description: "",
    });
  };
  CloseModal = () => {
    this.setState({
      addCatmodal: false,
      name: "",
      description: "",
      changeCreditLebelTitleName: false,
      id: ''
    });
    this.validator.hideMessages("");
  };
  componentDidMount = async () => {
    this.getAllCreditLebel();
    this.getcreditlebel();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getcreditlebel = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "newFrontier|creditLabel|getRefValue":
          this.setState(
            {
              getAllCreditLebelDetails: response.data,
              getAllCreditLebelDocs: [...(response.data.docs || [])].sort((a, b) =>
                a.name.trim().localeCompare(b.name.trim(), undefined, { sensitivity: "base" })
              ),
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
              if (this.tablistRef.current) this.tablistRef.current.updatedAt();
            }
          );
          break;
        case "newFrontier|creditLabel|add":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                addCatmodal: false,
              },
              this.setState({
                loaderFlag: false,
                name: "",
                description: "",
                changeCreditLebelTitleName: false,
              }),
              this.apiserve.success("CreditLabel created successful.")
            );
          }
          this.getAllCreditLebel();
          break;
        case "newFrontier|creditLabel|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
          this.setState(
            {
              addCatmodal: false,
              changeCreditLebelTitleName: false,
            },
            this.setState({ loaderFlag: false }),

            this.apiserve.success("CreditLabel updated Successful.")
          );
          }
          this.getAllCreditLebel();
          break;
        case "newFrontier|creditLabel|remove":
          this.getAllCreditLebel();
          break;
      }
    });
  };

  getAllCreditLebel = () => {
    this.apiserve.sendevent("newFrontier|creditLabel|getRefValue", {});
  };

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value.trimStart(),
    });
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      if (this.state.changeCreditLebelTitleName) {
        let updatecreditLabel = {
          name: this.state.name.trim(),
          description: this.state.description.trim(),
          creditLabelId: this.state.id,
        };
        this.apiserve.sendevent("newFrontier|creditLabel|update", updatecreditLabel);
      } else {
        let data = {
          name: this.state.name.trim(),
          description: this.state.description.trim(),
        };
        this.apiserve.sendevent("newFrontier|creditLabel|add", data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  editCreditLebeUser = async (item) => {
    this.setState({
      addCatmodal: true,
      changeCreditLebelTitleName: true,
      name: item.name,
      description: item.description,
      id: item._id,
    });
  };

  deleteCreditLebeUser = async (item) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Your record has been deleted!", {
          icon: "success",
        });
        let data = {
          creditLabelId: item._id,
        };
        this.apiserve.sendevent("newFrontier|creditLabel|remove", data);
      } else {
        swal("Your record is safe!");
      }
    });
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };
  render() {
    const { getAllCreditLebelDocs, changeCreditLebelTitleName } = this.state;
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <Tablist activeNF="NEW FRONTIER" name='creditNF' ref={this.tablistRef} />
            <div className="cat_outer_content">
              <div className="category_add_edit">
                <div className="category_header relative">
                  <p>New Frontier Credit Label </p>
                  <span className="add_icon d_flex" onClick={this.AddCategory}>
                    <FpgPlusIcon
                      width="16"
                      height="16"
                      color="#ffffff"
                      stroke="#4F4F4F"
                    />
                  </span>
                </div>
                <div className="list_wrap striped_droppable_table">
                  <ul>
                    {getAllCreditLebelDocs.map((item, index) => (
                      <li
                        key={item._id}
                        className="pointer d_flex d_flex_align_center"
                      >
                        <p className="cat_name">{item.name}</p>
                        <div className="action d_flex d_flex_align_center">
                          <span
                            className="cat_edit pointer"
                            onClick={() =>
                              this.editCreditLebeUser(item)
                            }
                          >
                            <CatEditIcon />
                          </span>
                          <span
                            className="remove_cat pointer"
                            onClick={() =>
                              this.deleteCreditLebeUser(item)
                            }
                          >
                            <FpgMinusIcon
                              width="16"
                              height="16"
                              color="#4F4F4F"
                            />
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
            >
              <span className="popup_overlay" onClick={this.CloseModal}></span>
              <div className="cat_modal_inner">
                <p className="cat_title text_center">
                  {changeCreditLebelTitleName
                    ? "Edit New Frontier Credit Label"
                    : "New Frontier Credit Label"}
                </p>
                <form>
                  <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Credit Label"
                      name="name"
                      value={this.state.name}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Credit Label",
                        this.state.name,
                        "required"
                      )}
                    />
                  </div>
                  <div className="field_row horizontal_field d_flex">
                    <label>Credit Label Description</label>
                    <div className="textarea_wrap">
                      <textarea
                        type="text"
                        rows="12"
                        name="description"
                        value={this.state.description}
                        onChange={this.onInputChange}
                      ></textarea>
                      <span style={{ color: "red" }}>
                        {this.validator.message(
                          "Description",
                          this.state.description,
                          "required"
                        )}
                      </span>
                    </div>
                  </div>
                  {/* <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Eventive ID"
                      name="eventiveId"
                      value={this.state.eventiveId}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Eventive ID",
                        this.state.eventiveId,
                        "required"
                      )}
                    />
                  </div> */}
                  <div className="cat_btns text_center">
                    <button type="button" onClick={this.CloseModal}>
                      CANCEL
                    </button>
                    <button
                      className="active"
                      onClick={(e) => this.submitFn(e)}
                    >
                      SAVE
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default FilmCreditLebel;
